import { useTranslation } from 'react-i18next';
import { useReveal } from '../../hooks/useReveal';
import AppLoop from './AppLoop';

export default function PVAndroid() {
  const { t } = useTranslation();
  const ref = useReveal({ stagger: 0.07 });
  const bullets = t('pv.android.bullets', { returnObjects: true });

  return (
    <section
      ref={ref}
      id="android"
      className="section"
      style={{ background: 'var(--p2a-dark-bg)', borderBottom: '1px solid var(--p2a-dark-border)' }}
    >
      <div
        className="p2-container pv-android-grid"
        style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 64, alignItems: 'center' }}
      >
        <div>
          <div className="eyebrow reveal" style={{ marginBottom: 20 }}>
            <span className="dot" />{t('pv.android.eyebrow')}
          </div>
          <h2 className="h-1 reveal">
            {t('pv.android.title_line1')} <span style={{ color: 'var(--p2a-green-400)' }}>{t('pv.android.title_line2_highlight')}</span>
          </h2>
          <p className="reveal" style={{ marginTop: 20, fontSize: 16, lineHeight: 1.6, color: 'var(--p2a-dark-fg-2)' }}>
            {t('pv.android.p')}
          </p>
          <ul className="reveal" style={{ listStyle: 'none', padding: 0, margin: '28px 0 0', display: 'flex', flexDirection: 'column', gap: 10 }}>
            {bullets.map((b) => (
              <li key={b} style={{ display: 'flex', gap: 12, alignItems: 'flex-start', fontSize: 14.5, color: 'var(--p2a-dark-fg-2)' }}>
                <span style={{ color: 'var(--p2a-green-500)', marginTop: 3 }}>→</span>
                <span>{b}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="reveal" style={{ display: 'flex', justifyContent: 'center' }}>
          <div style={{
            width: 280, height: 560,
            borderRadius: 32,
            border: '1px solid var(--p2a-dark-border-2)',
            background: '#0b0f14',
            padding: 10,
            boxShadow: '0 24px 48px -12px rgba(0,0,0,0.6), inset 0 0 0 1px rgba(255,255,255,0.02)',
            position: 'relative',
          }}>
            <div style={{
              position: 'absolute', top: 14, left: '50%', transform: 'translateX(-50%)',
              width: 100, height: 22, borderRadius: 14, background: '#000',
              zIndex: 2,
            }} />
            <div style={{
              width: '100%', height: '100%',
              borderRadius: 22,
              overflow: 'hidden',
              position: 'relative',
              background: '#0b0f14',
            }}>
              <AppLoop />
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 820px) {
          .pv-android-grid { grid-template-columns: 1fr !important; gap: 48px !important; }
        }
      `}</style>
    </section>
  );
}
